<template>
  <v-card>
    <loading
      slot="activator"
      :active.sync="isLoadingOrSaving"
      :can-cancel="false"
      loader="dots"
      :color="appColor_Progress"
    />
    <template v-if="customers.length === 0 && !isLoading">
      <h1 class="font-weight-light">
        No accounts found
      </h1>
    </template>
    <template v-else>
      <!-- Toolbar -->
      <v-toolbar
        dark
        flat
        :color="appColor_Medium"
        >

        <!-- Cancel -->
        <v-btn
          icon
          dark
          @click="cancel"
          >
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title>{{ selectedAccount }}</v-toolbar-title>
        <v-spacer />

        <!-- OK -->
        <v-toolbar-items>
          <v-btn
            :disabled="selected.length === 0 || isSaving"
            :loading="isSaving"
            dark
            :color="appColor_Medium"
            @click="select"
            class="elevation-0"
            >
            OK
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <!-- Search Text -->
      <v-list-item>
        <v-card-text>
          <v-text-field
            v-model="search"
            class="pt-0 pb-0"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-text>
      </v-list-item>

      <v-container
        :style="{ maxHeight: '600px', backgroundColor: 'white' }"
        class="overflow-y-auto pa-0"
        >
        <!-- Data Table -->
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="customers"
          :loading="isLoading"
          :search="search"
          :sort-desc.sync="sortDesc"
          :footer-props="{'items-per-page-options': [10]}"
          show-select
          single-select
          hide-default-header
          item-key="accountId"
          class="pa-1"
          >
          <v-progress-linear
            v-slot:progress
            :color="appColor_Progress"
            indeterminate
          />
          <template v-slot:item.accountId="{ item }">
            <span>
              {{ item.accountId }}
            </span>
          </template>
        </v-data-table>
      </v-container>
    </template>      
  </v-card>
</template>

<script>
import appService from '@/app.service'
import { AppColor } from '@/config.js'

export default {
  name: 'HxCustomerSelector',
  props: {
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      appColor_Medium: AppColor.Medium,
      appColor_Progress: AppColor.Progress,

      isLoading: true,
      selected: [],
      customers: [],
      search: '',
      sortDesc: false,
      headers: [
        {
          text: 'Account ID',
          value: 'accountId',
          align: 'left',
          width: '100%'
        }
      ]
    }
  },
  computed: {
    selectedAccount () {
      if (this.selected.length > 0) {
        return this.selected[0].accountId
      }
      return 'Select Account'
    },
    isLoadingOrSaving () {
      return this.isLoading || this.isSaving
    }
  },
  methods: {
    loadData () {
      const self = this
      self.isLoading = true
      appService.getHerdtraxAccounts().then(data => {
        self.customers = data
        self.isLoading = false
      })
    },

    select () {
      const accountId = this.selected[0].accountId
      this.$emit('select', accountId)
    },

    cancel () {
      this.$emit('cancel')
      this.reset ()
    },

    reset () {
      const self = this
      setTimeout(() => {
        self.search = ''
        self.isLoading = false
        self.selected = []
        self.sortDesc = false
      }, 300)
    },
  },
  watch: {
    isSaving (value) {
      if (value === null) return
      if (!value) this.reset()
    }
  },
  created () {
    this.loadData()
  }
}
</script>
